import { ChangeEvent } from 'react'
import cn from 'classnames'

import IconCross from 'app/common/icons/IconCross'
import Link from 'app/common/lib/link'
import PlainTooltip from 'app/common/ui-next/plain-tooltip'

import styles from './ModalExtendedHeader.module.scss'

type Props = {
  header?: any
  extra?: any
  onIconCrossClick?: (e: ChangeEvent<HTMLElement>) => void
  closePath?: string
  className?: string
}

const ModalExtendedHeader = ({ header, extra, onIconCrossClick, closePath, className }: Props) => {
  if (!header) {
    return null
  }

  return (
    <div className={cn(styles.header, className)}>
      {typeof header === 'string' ? (
        <PlainTooltip
          text={header}
          className={styles.headerText}
          popupContentClassName={styles.tooltipContent}
          hideWithoutOverflow
        >
          {header}
        </PlainTooltip>
      ) : (
        header
      )}

      {extra}

      {(onIconCrossClick || closePath) && (
        <Link to={closePath || ''} onClick={onIconCrossClick} className={styles.close}>
          <IconCross />
        </Link>
      )}
    </div>
  )
}

ModalExtendedHeader.defaultProps = {
  closePath: '',
}

export default ModalExtendedHeader
